import { render, staticRenderFns } from "./PenaltyPopover.vue?vue&type=template&id=971cfcac&scoped=true&"
import script from "./PenaltyPopover.vue?vue&type=script&lang=js&"
export * from "./PenaltyPopover.vue?vue&type=script&lang=js&"
import style0 from "./PenaltyPopover.vue?vue&type=style&index=0&id=971cfcac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "971cfcac",
  null
  
)

export default component.exports